<template>
  <div id="app">
    <head-Back title="管理中心"></head-Back>
    <div class="page">
      <div class="miyou-info">
        <span class="miyou-info-name">聊天号</span>
        <span class="miyou-info-num">{{ code }}</span>
      </div>
      <div class="app-info"></div>

      <div class="app-name">
        <img src="../../assets/img/app-info-name@2x.png" alt />
        <div class="app-ba-content">使用“天下事”</div>
      </div>
      <div class="app-info-logo">
        <div class="app-info-logo-mian"></div>
        <img src="../../assets/img/app-txs@2x.png" alt />
      </div>

      <div class="app-name anzhuang">
        <img src="../../assets/img/app-info-name-1@2x.png" alt />
        <div class="app-ba-content">安装指南</div>
      </div>

      <div class="app-ba">
        <img src="../../assets/img/center-lo-1@2x.png" alt />
        <div class="app-ba-content">首次使用，输入“0000”进入设置页面</div>
      </div>

      <img class="anzhuangimg-1" src="../../assets/img/pp-info-demo-txs@2x.png" alt />

      <div class="app-ba app-ba-mar">
        <img src="../../assets/img/center-lo-1@2x.png" alt />
        <div class="app-ba-content">
          非首次登录，输入已绑定账号下任意一个
          <br />聊天号的密码即可进入聊天界面
        </div>
      </div>

      <img class="anzhuangimg" src="../../assets/img/app-info-demo-txs@2x.png" alt />

      <router-link to="downapp">
        <button class="anzhung-button"></button>
      </router-link>
      <footAppinfo></footAppinfo>
    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back-down";
import footAppinfo from "../common/footAppinfotxs";
//toast组件

import util from "@/utils/util";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import api from "../../api/index";
import tips from "@/estoast";

export default {
  metaInfo: {
    title: "管理中心"
  },
  name: "app",
  data() {
    return {
      msg: "管理中心",
      code: "234555333"
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");
     var code = this.getCode;
              console.log("code:" + code);

              this.code = code;

  },
  methods: {
    getTokenUserInfo() {
     
      
    }
  },
  beforeCreate() {
    var token = util.getParams("token");

    console.log("页面加载开始 token:" + token);

    var ua = navigator.userAgent;
    console.log("页面加载开始 ua:" + JSON.stringify(ua));
    if(ua.indexOf('(qml)') > 0){
      console.log("页面加载开始 ua flag:" + true);

      store.commit(types.SET_APP_FLAG, true);
    }

    if (token == null || token == undefined) {
      //关闭浏览器
      window.location.href = "hqml://closeWindow";
    }
    store.commit(types.LOGIN, token);
    localStorage.setItem('token', token);

    this.$axiosHttp({
      method: "POST",
      url: api.qml.getuserInfo,
      data: { flag: 1 }
    })
      .then(res => {
        if (res.code == 0) {
          this.userInfo = res.result;
          //将对应的数据保存到Vuex中
          console.log("有效期：" + res.result.validitydate);
          console.log("有效期：" + res.result.viptype);

          store.commit(types.SET_USERINFO, res.result);
          store.commit(types.SET_TOKEN_SCOKET, res.result.socketToken);

          store.commit(types.SET_USERLIST, res.result.userRelList);
          store.commit(types.SET_CODE, res.result.userRelList[0].code);
        } else {
          tips.toast(res.message);
        }
      })
      .catch(err => {
        tips.toast(err);
        console.log(err);
      });
  },
  components: {
    headBack,
    footAppinfo
  },
  computed: {
    ...mapGetters([
      "getCode",
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  }
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: auto;
  background-image: url("../../assets/img/background@2x.png");
  -moz-background-size: 100% 100%;
  background-size: 100% 100%;
  padding: 28px 0px 0px 0px;
}
.miyou-info {
  width: 616px;
  height: 152px;
  background: rgba(44, 49, 99, 1);
  border-radius: 24px;
  margin: 0 auto 40px;
}
.miyou-info-name {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 152px;
}
.miyou-info-num {
  width: 180px;
  height: 50px;
  font-size: 42px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: rgba(245, 195, 167, 1);
  line-height: 12px;
  margin: 35px 0 0 22px;
}

.app-name {
  width: 369px;
  height: 44px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
  margin: 0 auto;
}

.app-name img {
  width: 100%;
  height: 1;
}

.anzhuang {
  width: 296px;
  height: 44px;
  margin-top: 60px;
}
.anzhuangimg-1 {
  width: 360px;
  height: 640px;
}

.anzhuangimg {
  width: 570px;
  height: 402px;
}

.app-ba {
  width: 670px;
  height: 46px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
  margin: 46px auto 34px auto;
}

.app-ba-mar {
  margin: 60px auto 86px auto;
}

.app-ba img {
  width: 100%;
  height: 10px;
}

.app-ba-content {
  position: relative;
  top: -35px;
}

.app-info-logo img {
  width: 104px;
  height: 104px;
  margin: 58px auto 0 auto;
}

.app-info-logo-mian {
  /* background: url("../../assets/img//miaofu@2x.png"); */
  width: 64px;
  height: 32px;
  background-size: 100% 100%;
  position: absolute;
  margin: 45px 0 0 426px;
}

.anzhung-button {
  background: url("../../assets/img/app-info-button.png");
  width: 298px;
  height: 68px;
  background-size: 100% 100%;
  border: none;
  margin: 42px auto 168px auto;
}
</style>


// WEBPACK FOOTER //
// src/components/page/userAppInfotxs.vue